module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921113834_T.7a62ad0a.jpg";